import { render } from "./examPointManager.vue?vue&type=template&id=316ac6d7"
import script from "./examPointManager.vue?vue&type=script&lang=js"
export * from "./examPointManager.vue?vue&type=script&lang=js"

import "./examPointManager.vue?vue&type=style&index=0&id=316ac6d7&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__